import React, { useEffect, useState } from "react";
import axios from "axios";
import serverConfig from "../config";
import "./Home.css";
import UpdatePaths from "../utils/UpdatePaths";
import SecondaryMenu from "../SecondaryMenu";

import toast, { Toaster } from "react-hot-toast";
function History() {
  const [contentHistory, setContentHistory] = useState(null);

  /*
  useEffect(() => {
    axios
      .get(`${serverConfig.serverUrl}/get_history`)
      .then((response) => {
        const data = response.data;
        const data_update = UpdatePaths(data, "img/history/", "");
        setContentHistory(data_update);
      })
      .catch((error) => {
        //alert("ERRORE | get_history");
        toast.error("La risorsa non è al momento disponibile");
      });
  }, []);
  */

 const language = localStorage.getItem("language_dsm") || "it";

  useEffect(() => {
    axios
      .post(`${serverConfig.serverUrl}/get_history`, { language: language.toLocaleLowerCase() })
      .then((response) => {
        const data = response.data;
        const data_update = UpdatePaths(data, "img/history/", "");
        setContentHistory(data_update);
      })
      .catch((error) => {
        toast.error("La risorsa non è al momento disponibile");
      });
  }, []);

  const [showSidebar, setShowSidebar] = useState(window.innerWidth > 992);

  const handleResize = () => {
    if (window.innerWidth > 992) {
      setShowSidebar(true);
    } else {
      setShowSidebar(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const componentsHistory = (
    <>
      <div dangerouslySetInnerHTML={{ __html: contentHistory }} />
    </>
  );

  return (
    <div>
      {/*
      <div className="row">
        <div className="col-12 col-lg-2">
          <SecondaryMenu vertical={true}></SecondaryMenu>
        </div>
        <div className="col-12 col-lg-10">
          <div dangerouslySetInnerHTML={{ __html: contentHistory }} />
        </div>
      </div>
      */}

      <div
        className={`row home-container ${
          showSidebar ? "show-sidebar" : "hide-sidebar"
        }`}
      >
        <Toaster />
        <button
          className="show-sidebar-button"
          onClick={() => setShowSidebar(!showSidebar)}
        >
          {showSidebar ? "Nascondi Menu" : "Mostra Menu"}
        </button>

        {window.innerWidth <= 992 ? (
          showSidebar ? (
            <div className="col-12">
              <SecondaryMenu vertical={true}></SecondaryMenu>
            </div>
          ) : (
            <div className={`main-content col-12`}>{componentsHistory}</div>
          )
        ) : (
          <>
            <div className="col-2 sidebar-left">
              <SecondaryMenu vertical={true}></SecondaryMenu>
            </div>
            <div
              className={`main-content ${showSidebar ? "col-10" : "col-12"}`}
            >
              {componentsHistory}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default History;
